import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Ionicons } from "@expo/vector-icons";

const RentPeriodSelector = ({
  heading,
  items,
  selected,
  onSelection,
  error,
}) => {
  const [current, setCurrent] = useState(selected);

  useEffect(() => {
    setCurrent(selected);
  }, [selected]);

  const handleSelect = (value) => {
    setCurrent(value);
    onSelection(value);
  };
  console.log("current",current,items)

  return (
    <Grid item xs={12}>
      <Typography
        fontSize={16}
        fontWeight={500}
        mb={1.5}
        color="#6A6A80"
      >
        {heading}
      </Typography>

      <Grid container spacing={1.8}>
        {items.map((item, index) => {
          const isActive =
            current?.toUpperCase() === item.value.toUpperCase();

          return (
            <Grid item xs={12} sm={6} key={index}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSelect(item.value)}
                sx={{
                  height: 44,
                  borderRadius: 1,
                  padding: "0px 14px",
                  borderColor: isActive ? "#9C6CFF" : "#D6D6E8",
                  borderWidth: isActive ? 2 : 1,
                  backgroundColor: "#fff",
                  justifyContent: "flex-start",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#9C6CFF",
                  },
                }}
              >
                {/* Icon (Expo Ionicons) */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mr: 1.4,
                    color: isActive ? "#9C6CFF" : "#BFC0CC",
                  }}
                >
                  <Ionicons
                    name={isActive ? "radio-button-on" : "radio-button-off"}
                    size={22}
                    color={isActive ? "#9C6CFF" : "#BFC0CC"}
                  />
                </Box>

                {/* Label */}
                <Typography
                  sx={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#4A4A4A",
                  }}
                >
                  {item.label}
                </Typography>
              </Button>
            </Grid>
          );
        })}

        {error && (
          <Grid item xs={12}>
            <Typography color="error" variant="body2" mt={0.5}>
              {typeof error === "string" ? error : error.message}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default RentPeriodSelector;
